/**
 * @file LegalDocumentEditPage.tsx
 * @description Карточка юридического документа (phase10.5.X; phase19.16 —
 * виды «Текст / PDF / Группа», черновик и редакции, SB139–SB144).
 *
 * Под SHOP_MANAGE_SETTINGS (маршрут, SB144). Страница — только раскладка:
 *   - `new` → `LegalDocumentCreateView` (вид из `?kind=`, без него — выбор вида);
 *   - иначе → `LegalDocumentCardView` (поля, секция вида, редакции, окна
 *     снятия и удаления).
 * Публичная отдача — `/legal/<адрес>` на витрине (оферта — `/offer`,
 * политика ПДн — `/privacy`).
 */

import { useParams } from "react-router";

import { LegalDocumentCardView } from "../../../components/legal-docs/LegalDocumentCardView";
import { LegalDocumentCreateView } from "../../../components/legal-docs/LegalDocumentCreateView";

export function LegalDocumentEditPage() {
  const { id } = useParams<{ id?: string }>();
  // Карточку пересоздаём по id: состояние формы прежнего документа не переносится.
  return !id || id === "new" ? <LegalDocumentCreateView /> : <LegalDocumentCardView key={id} id={id} />;
}
